export const PRIVACY_TITLE = 'Privacy Policy';
export const PRIVACY_DESC = 'Our website allows developers to receive SMS online for testing. We provide disposable/temporary phone numbers so you can test 2FA using SMS.';

export const CONTACT_US = 'Contact Us';
export const CONTACT_DESC = 'Our website allows developers to receive SMS online for testing. We provide disposable/temporary phone numbers so you can test 2FA using SMS.';

